import { ObjectAction } from "./object-action.model";

export class ObjectActionWithObject {

    constructor(public action: ObjectAction, public on: any) {
    }
}
